import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import {Label} from 'bulk-workflows/BulkWorkflowComponents';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';
import {Cell, Column, Table} from 'ui-library/simple-table/SimpleTable';

import * as BulkTranslationActions from '../BulkTranslationActions';
import {BulkTranslation} from '../BulkTranslationConstants';
import * as BulkTranslationUtil from '../BulkTranslationUtil';

interface Props {
  bulkTranslation: BulkTranslation;
}

class BulkTranslationSummary extends React.Component<Props> {
  _handleRun = (): void => {
    BulkTranslationActions.run();
  };

  override render(): JSX.Element {
    const {bulkTranslation} = this.props;
    if (bulkTranslation.sequencesLoading) {
      return <HorizontalThrobber />;
    }
    const proteinNames = BulkTranslationUtil.getProteinNames(bulkTranslation);
    return (
      <div>
        <p>
          {proteinNames.length} {benchlingUtil.pluralize(proteinNames.length, 'AA sequence')} will be created.
        </p>
        <Label>Preview</Label>
        <Table numRows={proteinNames.length}>
          <Column renderCell={(rowIndex) => <Cell>{proteinNames[rowIndex]}</Cell>} />
        </Table>
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          size={ButtonSize.MEDIUM}
          disabled={bulkTranslation.isRunning || bulkTranslation.sequences.length < 1}
          text={bulkTranslation.isRunning ? 'Translating...' : 'Next: Translate'}
          onClick={this._handleRun}
        />
      </div>
    );
  }
}

export default BulkTranslationSummary;
